import hero from "./components/hero";
import navigation from "./components/navigation";
import animations from "./components/animations";
import imageContent from "./components/image-content";
import imageGallery from "./components/image-gallery";
import videoBlock from "./components/video-block";
import map from "./components/map";
import infinitescroll from "./components/infinitescroll";
import slideshow from "./components/slideshow";


import konduit from "./konduit/index";
import whatToDo from "./what-to-do/index";

import cookieBar from "../../../../../vendor/smokeylemon/gdpr-basics/client/src/js/cookieBar";
import lazyLoad from "./components/lazyLoad";

document.addEventListener("DOMContentLoaded", () => {
    cookieBar();
    navigation();
    hero();
    imageContent();
    imageGallery();
    videoBlock();
    map();
    infinitescroll();
    slideshow();
    lazyLoad();


    // init konduit
    konduit();
    whatToDo();

    animations();
});
